import TrackingDetails from "./trackingdetails";
import { ButtonPrimary, ButtonPrimarySm } from '../../components/formelements'
import { useHistory } from "react-router";
import { useState } from "react";
import { useEffect } from "react";
import { TrackingSignImageURL, TrackingCnImageURL } from "../../global";

const CNInfo = ({ data, index }) => {
    const history = useHistory();
    const [showImage, setShowImage] = useState(false)
    const [imageURLOne, setImageURLOne] = useState('')
    const [imageURLTwo, setImageURLTwo] = useState('')

    useEffect(() => {
        const isImageAvailable = async (urlParam,cn, setImageURL) => {
            const url = `${urlParam}/${cn}.jpg`
            // const url = 'http://20.46.47.21/mraabta/CnImage/074811113449983.jpg';
            var image = new Image();
            image.onload = function () {
                if (this.width > 0) {
                    setShowImage(true)
                    setImageURL(url)
                }
            }
            image.onerror = function () {
                setShowImage(false)
                setImageURL('')
            }
            image.src = url;
        }
        if (data.cnStatus === "DELIVERED") {
            isImageAvailable(TrackingSignImageURL, data.cn, setImageURLOne);
        }
        if(data.cnStatus === "UNDELIVERED") {
            isImageAvailable(TrackingCnImageURL, data.cn, setImageURLTwo);
        }
    }, [])

    return (
        <div className="row solid-divider" key={index}>
            <div className="col-12 text-center p-2">
                <h3 style={{ fontSize: 20 }}>Consignment Info</h3>
            </div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Consignment Number</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.cn}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Consigner</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.shipper}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Booking Date</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.bookingDate}</b></div>

            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Pieces</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.pieces}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Weight</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.weight}</b></div>

            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Service Type</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.serviceType}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Recieved By</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.receivedBy}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Destination</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.destination}</b></div>

            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Origin</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.origin}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Delivery Rider</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.courierName}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Current Status</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.cnStatus}</b></div>

            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Ticket No</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.ticketNo}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Ticket Status</b></div>
            <div className="col-md-2 col-sm-12 pb-2"><b>{data.ticketStatus ? data.ticketStatus === 1 ? 'Open' : 'Close' : ''}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Consignee</b></div>
            <div className="col-md-6 col-sm-12 pb-2"><b>{data.consignee}</b></div>
            <div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Consignee address</b></div>
            <div className="col-md-6 col-sm-12 pb-2"><b>{data.consigneeAdd}</b></div>
            {showImage && imageURLOne !== '' && <><div className="col-md-2 col-sm-12 pb-2 text-dark"><b>POD</b></div>
                <div className="col-md-2 col-sm-12 pb-2"><a href={imageURLOne} className="btn btn-primary" type="image/JPEG" target="_blank">View Signature</a></div></>}

            {showImage && imageURLTwo !== '' && <><div className="col-md-2 col-sm-12 pb-2 text-dark"><b>Sopport Image</b></div>
                <div className="col-md-2 col-sm-12 pb-2"><a href={imageURLTwo} className="btn btn-primary" type="image/JPEG" target="_blank">View</a></div></>}

            
            <div className="col pb-2" style={{ textAlign: 'right' }}>
                <ButtonPrimarySm text={(!data.ticketStatus || data.ticketStatus === 0) ? 'Launch Ticket' : 'View Ticket'} onClick={e => {

                    sessionStorage.setItem('complaintData', JSON.stringify({
                        cn: data.cn,
                        codAmount: data?.codAmount,
                        screen: 'tracking'
                    }));
                    history.push({
                        pathname: '/complaint'
                    });
                }} />
            </div>

            <div className="col-12 text-center p-2">
                <h3 style={{ fontSize: 20 }}>Tracking Info</h3>
            </div>
            <div className="col-12 table-rseponsive" style={{ height: "36vh", overflowX: "scroll", position: "relative" }}>
                <TrackingDetails data={data.details} />
            </div>
        </div>

    )
}

export default CNInfo;